<template>
  <treeselect
    v-if="entityTypes"
    ref="treeselect"
    v-model="internalValue"
    :disabled="deactivated"
    :options="selectableEntities"
    :show-count="true"
    showCountOf="LEAF_DESCENDANTS"
    :placeholder="placeholder"
    :disable-branch-nodes="true"
    :flatten-search-results="true"
    value-consists-of="LEAF_PRIORITY"
  >
  </treeselect>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";

import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  props: {
    value: {
      Type: Object | Array,
      default: null
    },
    placeholder: {
      Type: String | undefined,
      default: "Select a single entity type"
    },
    deactivated: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onEntityTypeSelected"],
  computed: {
    ...mapGetters({
      entityTypes: "userQueries/entityTypes"
    }),
    internalValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
        this.$emit("onEntityTypeSelected", v);
      }
    },
    selectableEntities() {
      return this.entityTypes.map(entityTypeInfo => {
        return { id: entityTypeInfo.enumValue + "", label: entityTypeInfo.name };
      });
    }
  }
};
</script>

<style lang="scss">
.vue-treeselect__multi-value {
  max-height: 180px;
  overflow-y: auto;
}
</style>